<template>
  <button
    class="button button-no-border button-outline-brand pdp-purchase-form-submit"
    :class="{
      'button-light': !selectedProductType,
      'button-fill': selectedProductType,
      'button-segmented': isSubscriptionBuilder
    }"
    type="submit"
  >
    <span>{{ buttonText }}</span>
    <svg v-if="isSubscriptionBuilder" class="icon icon-arrow-right">
      <use xlink:href="#icon-arrow-right" />
    </svg>
  </button>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { purchaseForm } from './store';

import { PRODUCT_TYPE, NEXT_STEP } from './const';

export default {
  computed: {
    ...mapState(purchaseForm, [
      'selectedProductType',
      'subscribe',
      'translations'
    ]),

    ...mapGetters(purchaseForm, ['isSubscriptionBuilder']),

    buttonText() {
      if (this.selectedProductType === PRODUCT_TYPE.SUBSCRIBE) {
        if (this.subscribe.nextStep === NEXT_STEP.ADD_TO_CART) {
          return this.translations.addToCart;
        } else if (this.subscribe.nextStep === NEXT_STEP.SUBSCRIPTION_BUILDER) {
          return this.translations.nextStep;
        }
      } else if (this.selectedProductType === PRODUCT_TYPE.ONETIME) {
        return this.translations.addToCart;
      }

      return this.translations.selectProduct;
    }
  }
};
</script>
